import React from 'react'
import ReactDOM from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { AuthProvider } from './hooks/AuthProvider';
import App from './App.tsx'
import './index.css'

console.log(
  `360 Lightning frontend starting | version=${__APP_VERSION__} ` +
  `git_branch=${__GIT_BRANCH__} git_commit=${__GIT_COMMIT__}`
);

const skipAuth = import.meta.env.VITE_SKIP_AUTH === 'true';
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

if (!skipAuth && !GOOGLE_CLIENT_ID) {
  console.error("VITE_GOOGLE_CLIENT_ID is not defined in environment variables!");
} else if (GOOGLE_CLIENT_ID) {
  console.log("Google Client ID loaded successfully: " + GOOGLE_CLIENT_ID.substring(0, 5) + "...");
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID || ""}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
)
